function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_7150",
  "data-name": "Group 7150",
  transform: "translate(-123.851 -620.48)"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_tick_3923816",
  transform: "translate(168.851 698.832)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3432",
  "data-name": "Path 3432",
  d: "M17,2A15,15,0,1,0,32,17,15,15,0,0,0,17,2Zm8.514,12.355-9,8.25a1.5,1.5,0,0,1-2.075-.045l-4.5-4.5a1.5,1.5,0,1,1,2.121-2.121l3.484,3.485,7.941-7.28a1.5,1.5,0,0,1,2.028,2.211Z",
  transform: "translate(-47 -79.832)",
  fill: "#f37320"
})), /*#__PURE__*/React.createElement("g", {
  id: "noun_Cross_2135404",
  transform: "translate(217.705 614)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3438",
  "data-name": "Path 3438",
  d: "M15,0h0A15,15,0,0,0,0,15H0A15,15,0,0,0,15,30h0A15,15,0,0,0,30,15h0A15,15,0,0,0,15,0Zm5.14,17.988c.765.72,1.032,1.574.241,2.376s-1.641.558-2.377-.2l-3.052-3.141c-1.074,1.143-2.01,2.151-2.96,3.146-.731.766-1.593.991-2.375.186s-.5-1.655.257-2.376l3.3-3.14c-1.177-1-2.238-1.866-3.26-2.776-.82-.731-1.127-1.635-.241-2.473.82-.775,1.668-.457,2.377.3.912.973,1.82,1.95,2.953,3.164,1.172-1.25,2.106-2.266,3.059-3.266a1.474,1.474,0,0,1,2.272-.194c.813.776.612,1.637-.154,2.374-.993.956-2,1.894-3.23,3.053C18.131,16.113,19.14,17.046,20.14,17.988Z",
  transform: "translate(-3 7)",
  fill: "#f37320"
})), /*#__PURE__*/React.createElement("g", {
  id: "noun_Man_4326500",
  transform: "translate(135.842 669.26)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3433",
  "data-name": "Path 3433",
  d: "M11.274,20.518l.678,2.028A1.979,1.979,0,0,0,13.827,23.9H15.9a1.979,1.979,0,0,0,1.875-1.355l.678-2.028L14.866,17.55Z",
  transform: "translate(32.622 72.198)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3434",
  "data-name": "Path 3434",
  d: "M10.124,17.635l9.4,9.4,9.4-9.4v-3.7a22.85,22.85,0,0,1-12.194,1.9,24.142,24.142,0,0,1-6.634-1.83Z",
  transform: "translate(27.965 57.495)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3435",
  "data-name": "Path 3435",
  d: "M12.249,15a.124.124,0,0,0-.168,0L8.662,18.416,14.6,31.807a.114.114,0,0,0,.084.069.134.134,0,0,0,.1,0l7.8-6.5Z",
  transform: "translate(22.312 61.82)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3436",
  "data-name": "Path 3436",
  d: "M22.875,15.018,12.521,25.367l7.811,6.5a.109.109,0,0,0,.1,0,.094.094,0,0,0,.079-.069l2.1-4.7,3.859-8.682-3.418-3.418a.114.114,0,0,0-.178.025Z",
  transform: "translate(37.544 61.804)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3437",
  "data-name": "Path 3437",
  d: "M83.383,84.742l-15.642-5.7a1.815,1.815,0,0,0-.43-.761l-4.264-4.4A3.533,3.533,0,0,0,60.384,72.8V69.228A23.691,23.691,0,0,0,67.8,61.463,25.1,25.1,0,0,0,70.521,55a25.693,25.693,0,0,0,.821-6.468c0-15.672,0-15.427-.04-16.07a1.857,1.857,0,0,0-1.019-1.609,1.75,1.75,0,0,0-1.853.188,1.882,1.882,0,0,0-.695,1.783c.04.419,0,.781,0,15.708,0,11.613-9.121,21.027-20.374,21.027S26.985,60.141,26.985,48.528c0-4.135-.042-7.264-.057-9.807a9.525,9.525,0,0,1,3.455-7.461A8.9,8.9,0,0,1,38.212,29.5c8.3,2.042,11.64,7.4,22.262,6.887a1.851,1.851,0,0,0-.168-3.7c-9.622.465-12.2-4.538-21.272-6.784a12.4,12.4,0,0,0-10.879,2.485,13.268,13.268,0,0,0-4.793,10.38c0,1.848.035,4.084.049,6.769A3.834,3.834,0,0,1,21.4,42.157V19.639a4.329,4.329,0,0,1,4.254-4.39,1.792,1.792,0,0,0,1.662-1.159A15.956,15.956,0,0,1,42.194,3.7H57.451A16.406,16.406,0,0,1,73.573,20.333V42.157a1.792,1.792,0,1,0,3.582,0V20.333C77.141,9.109,68.327.014,57.451,0H42.194A19.464,19.464,0,0,0,24.439,11.65a8.028,8.028,0,0,0-6.634,7.989V42.157a7.5,7.5,0,0,0,5.63,7.31c.049,0,.124,1.777.143,1.955q.114.98.3,1.945a24.862,24.862,0,0,0,9.9,15.55c.262.184.554.322.826.51v3.41a3.537,3.537,0,0,0-2.666,1.082l-4.264,4.4a1.806,1.806,0,0,0-.43.766L13.917,83.93l-3.463,1.332A13.369,13.369,0,0,0,3.009,97.315v23.432a1.762,1.762,0,0,0,1.731,1.606,1.762,1.762,0,0,0,1.731-1.606V97.315A10.027,10.027,0,0,1,7.08,93.89l8.8,7.749a5.946,5.946,0,0,1,1.979,4.462v14.615a1.817,1.817,0,0,0,.808,1.715,1.7,1.7,0,0,0,1.847,0,1.817,1.817,0,0,0,.808-1.715V106.1a9.593,9.593,0,0,0-3.2-7.188L8.9,90.761a9.385,9.385,0,0,1,3.834-2.634l15.5-5.646,5.486,12.762A3.6,3.6,0,0,0,36.2,97.351a3.463,3.463,0,0,0,3.122-.761l1.687-1.455.247.766a5.68,5.68,0,0,0,1.524,2.4l-3.567,22.145a1.791,1.791,0,0,0,1.43,2.042,1.87,1.87,0,0,0,.287,0,1.763,1.763,0,0,0,1.717-1.5l3.428-21.3h2.785l3.463,21.3a1.754,1.754,0,0,0,1.712,1.5,1.814,1.814,0,0,0,.287,0,1.786,1.786,0,0,0,1.43-2.042l-3.587-22.14A5.633,5.633,0,0,0,53.7,95.9l.242-.761,1.692,1.45a3.477,3.477,0,0,0,2.29.863,3.6,3.6,0,0,0,3.3-2.205l2.058-4.783h0l.579-1.337h0l2.825-6.636,15.529,5.661a9.385,9.385,0,0,1,3.829,2.629l-9.216,8.168a9.583,9.583,0,0,0-3.206,7.188v14.615a1.817,1.817,0,0,0,.808,1.715,1.7,1.7,0,0,0,1.847,0,1.817,1.817,0,0,0,.808-1.715V106.106a5.962,5.962,0,0,1,1.979-4.462l8.8-7.775a9.89,9.89,0,0,1,.608,3.425v23.427a1.817,1.817,0,0,0,.808,1.715,1.7,1.7,0,0,0,1.847,0,1.817,1.817,0,0,0,.808-1.715V97.295a13.309,13.309,0,0,0-8.543-12.553ZM51.633,72.883a23.093,23.093,0,0,0,5.274-1.725v3.813l-9.419,9.72-9.4-9.7V71.26a23.562,23.562,0,0,0,6.634,1.889,22.815,22.815,0,0,0,6.911-.255ZM37.1,93.818a.13.13,0,0,1-.1,0,.115.115,0,0,1-.084-.071L30.974,79.928,34.393,76.4a.121.121,0,0,1,.168,0L44.91,87.085Zm13.288.929a1.985,1.985,0,0,1-1.875,1.4H46.434a1.985,1.985,0,0,1-1.875-1.4l-.678-2.093,3.592-3.063,3.592,3.063Zm9.746-5.83-2.1,4.855a.1.1,0,0,1-.079.071.106.106,0,0,1-.1,0l-7.8-6.708L60.4,76.457a.111.111,0,0,1,.168,0l3.418,3.528Z",
  transform: "translate(0 0)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_7148",
  "data-name": "Group 7148",
  transform: "translate(-95.414 208.696)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3840",
  "data-name": "Path 3840",
  d: "M10319.037,714.788s4.239,8.875,12.343,8.543,10.972-5.9,12.422-8.543",
  transform: "translate(-10053 -282)",
  fill: "none",
  stroke: "#f26700",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3841",
  "data-name": "Path 3841",
  d: "M10318.3,709.5h26.855s-.552-11.21-10.687-13.774-15.506,7.352-15.527,8.409",
  transform: "translate(-10053 -282)",
  fill: "none",
  stroke: "#f26700",
  strokeLinecap: "round",
  strokeWidth: 3
})));

function SvgStepper3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.854,
    height: 171.52,
    viewBox: "0 0 120.854 171.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepper3);
export default __webpack_public_path__ + "static/media/stepper3.4b84fd806a559f96d4c14d6d62a40070.svg";
export { ForwardRef as ReactComponent };